import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f4ec876"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "training-state" }
const _hoisted_2 = {
  key: 0,
  class: "material-icons-round"
}
const _hoisted_3 = {
  key: 1,
  class: "material-icons-round success"
}
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "publish-state" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "update", -1))
const _hoisted_10 = { class: "language" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_md_select = _resolveComponent("md-select")!
  const _component_top_nav = _resolveComponent("top-nav")!

  return (_openBlock(), _createBlock(_component_top_nav, { logo: false }, {
    left: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.trainingRequired)
          ? (_openBlock(), _createElementBlock("i", _hoisted_2, "model_training"))
          : (_openBlock(), _createElementBlock("i", _hoisted_3, "check_circle")),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.trainingRequired)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_5, "Training ausstehend"))
            : (_openBlock(), _createElementBlock("h3", _hoisted_6, "Modelle trainiert")),
          _createElementVNode("span", null, _toDisplayString(_ctx.untrainedModelLanguagesLabel), 1)
        ]),
        _createVNode(_component_router_link, { to: { name: 'BotTrainingModels' } }, {
          default: _withCtx(() => [
            (_ctx.trainingRequired)
              ? (_openBlock(), _createBlock(_component_md_button, {
                  key: 0,
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Details ansehen")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    right: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_md_button, {
          variant: "tonal",
          icon: "publish",
          onClick: _ctx.publish
        }, {
          default: _withCtx(() => [
            _createTextVNode("Veröffentlichen")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_md_select, {
          icon: "language",
          variant: "flat",
          modelValue: _ctx.language,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.language) = $event)),
          items: _ctx.items
        }, null, 8, ["modelValue", "items"])
      ])
    ]),
    _: 1
  }))
}